import { getComposeHostItemIndex, lazyDeinitializeAddinsForItem } from 'owa-addins-core';
import { isFeatureEnabled } from 'owa-feature-flags';
import protectMessage from 'owa-mail-protection/lib/utils/rms/protectMessage';
import { ComposeViewState } from 'owa-mail-compose-store';

export default function protectMessageAndRemoveAddin(
    composeViewState: ComposeViewState,
    templateId: string
) {
    let { protectionViewState, composeId, bodyType } = composeViewState;
    let isProtectionApplied = protectMessage(
        protectionViewState,
        composeViewState,
        templateId,
        bodyType
    );

    isProtectionApplied &&
    isFeatureEnabled('rp-addins') && // add-ins need to be deinitialized, don't support IRM/SMIME
        lazyDeinitializeAddinsForItem.import().then(deinitializeAddinsForItem => {
            deinitializeAddinsForItem(getComposeHostItemIndex(composeId));
        });
}
